var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 10.3333L26.5 2.00001M26.5 2.00001H18.1666M26.5 2.00001L14 14.5M11.2222 2H8.16667C5.83311 2 4.66634 2 3.77504 2.45414C2.99103 2.85361 2.35361 3.49103 1.95414 4.27504C1.5 5.16634 1.5 6.33311 1.5 8.66667V20.3333C1.5 22.6669 1.5 23.8337 1.95414 24.725C2.35361 25.509 2.99103 26.1464 3.77504 26.5459C4.66634 27 5.83311 27 8.16667 27H19.8333C22.1669 27 23.3337 27 24.225 26.5459C25.009 26.1464 25.6464 25.509 26.0459 24.725C26.5 23.8337 26.5 22.6669 26.5 20.3333V17.2778",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalResources);
export default __webpack_public_path__ + "static/media/external-resources.ae9365cae7c5e6a507967e899393ff6c.svg";
export { ForwardRef as ReactComponent };